export const workspacePresentations = {
  atendimento: {
    title: 'Atendimento e assistentes',
    sections: {
      conversation: 'Conversas, envio e encaminhamento',
      context: 'Painel lateral do cliente',
      help: 'Orientações dos modos de atendimento',
    },
    essentialSections: ['conversation'],
    fields: { today: 'Resumo de atividade da assistente' },
    compactSections: ['conversation'],
  },
  automacoes: {
    title: 'Automações',
    sections: {
      rules: 'Regras, execução e resultados',
      help: 'Orientações sobre o benefício das regras',
    },
    essentialSections: ['rules'],
    fields: { placeholders: 'Ajuda das variáveis de mensagem' },
    compactSections: ['rules'],
  },
  campanhas: {
    title: 'Campanhas da loja',
    sections: {
      operations: 'Preparação, vigência e aprovação',
      history: 'Campanhas e situações',
      help: 'Orientações de preparação',
    },
    essentialSections: ['operations', 'history'],
    fields: { version: 'Número da versão na lista' },
    compactSections: ['operations', 'history'],
  },
  'pedidos-online': {
    title: 'Pedidos e reservas online',
    sections: { orders: 'Pedidos, valores e operações', help: 'Explicações de reserva' },
    essentialSections: ['orders'],
    fields: {
      createdAt: 'Data de criação do pedido',
      expandedItems: 'Itens do pedido sempre expandidos',
      expandedHistory: 'Histórico de pagamento sempre expandido',
    },
    compactSections: ['orders'],
  },
  'assistentes-comerciais': {
    title: 'Preparar assistentes',
    sections: { identity: 'Identidade, regras e ativação' },
    essentialSections: ['identity'],
    fields: { personality: 'Jeito de conversar', language: 'Idioma', timezone: 'Edição do fuso' },
    compactSections: ['identity'],
  },
  balcao: {
    title: 'PDV da equipe',
    sections: { operation: 'Venda e caixa', help: 'Orientações do balcão' },
    essentialSections: ['operation'],
    fields: {},
    compactSections: ['operation'],
  },
  loja: {
    title: 'Editor da loja',
    sections: { editor: 'Produtos, contato, regras e publicação', help: 'Dicas de identidade' },
    essentialSections: ['editor'],
    fields: {
      tagline: 'Frase de apresentação',
      about: 'Sobre a loja',
      featuredCategory: 'Categoria de destaque',
    },
    compactSections: ['editor'],
  },
  publicacao: {
    title: 'Publicação local',
    sections: { operations: 'Revisão, aceite e publicação', history: 'Histórico local' },
    essentialSections: ['operations', 'history'],
    fields: { hostname: 'Endereço no histórico' },
    compactSections: ['operations', 'history'],
  },
  posvenda: {
    title: 'Atendimento e pós-venda',
    sections: {
      operation: 'Itens, revisão e confirmação',
      history: 'Devoluções registradas',
      help: 'Orientações das etapas',
    },
    essentialSections: ['operation', 'history'],
    fields: { date: 'Editar a data da devolução' },
    compactSections: ['operation', 'history'],
  },
  caixa: {
    title: 'Caixa e fechamento',
    sections: {
      sessions: 'Sessões, conferência e operações',
      history: 'Detalhe dos movimentos',
      help: 'Explicações de abertura',
    },
    essentialSections: ['sessions'],
    fields: { terminal: 'Terminal na abertura' },
    compactSections: ['sessions'],
  },
  recebiveis: {
    title: 'Cobranças e recebimentos',
    sections: {
      titles: 'Títulos e operações',
      balances: 'Saldos registrados',
      help: 'Explicações de recebimento',
    },
    essentialSections: ['titles'],
    fields: {
      forecastFee: 'Taxas previstas e comparação no histórico',
      competence: 'Data de competência',
    },
    compactSections: ['titles'],
  },
  agenda: {
    title: 'Agenda',
    sections: { appointments: 'Agendamentos e ações' },
    essentialSections: ['appointments'],
    fields: { avatar: 'Avatar do cliente', creator: 'Selo de agendamento pela assistente' },
    compactSections: ['appointments'],
  },
  conhecimento: {
    title: 'Informações da empresa',
    sections: { knowledge: 'Informações e edição' },
    essentialSections: ['knowledge'],
    fields: { category: 'Categoria no formulário', keywords: 'Palavras-chave no formulário' },
    compactSections: ['knowledge'],
  },
  crm: {
    title: 'Clientes e oportunidades',
    sections: { contacts: 'Clientes', opportunities: 'Oportunidades' },
    essentialSections: ['contacts', 'opportunities'],
    fields: {
      email: 'E-mail no cadastro',
      phone: 'Telefone no cadastro',
      procedure: 'Interesse ou procedimento',
      urgency: 'Urgência',
      insurance: 'Condição de atendimento',
      preferredPeriod: 'Período preferido',
      opportunityTitle: 'Descrição da oportunidade na lista',
    },
    compactSections: ['contacts', 'opportunities'],
  },
  encomendas: {
    title: 'Encomendas e produção',
    sections: {
      orders: 'Encomendas',
      production: 'Produção',
      materials: 'Materiais e custos',
      field: 'Serviços de campo',
      payments: 'Sinal e entrega',
      art: 'Aprovação de arte',
    },
    essentialSections: ['orders', 'production', 'payments', 'art'],
    fields: { personalization: 'Descrição da personalização' },
    compactSections: ['orders', 'production', 'payments', 'art'],
  },
  compras: {
    title: 'Compras e fornecedores',
    sections: { purchase: 'Criar e receber compras', history: 'Pedidos de compra' },
    essentialSections: ['purchase', 'history'],
    fields: { freight: 'Frete da compra', discount: 'Desconto da compra' },
    compactSections: ['purchase', 'history'],
  },
  vendas: {
    title: 'PDV e vendas',
    sections: { sale: 'Venda', history: 'Histórico de vendas' },
    essentialSections: ['sale', 'history'],
    fields: {
      discount: 'Desconto por item',
      customerRegistration: 'Cadastro rápido de cliente',
      shortcuts: 'Orientações de teclado e leitura',
      paymentForecast: 'Detalhamento das parcelas na revisão',
    },
    compactSections: ['sale', 'history'],
  },
  estoque: {
    title: 'Estoque e reposição',
    sections: {
      operations: 'Movimentar estoque',
      balances: 'Saldos por local',
      history: 'Histórico detalhado',
    },
    essentialSections: ['operations', 'balances'],
    fields: { minimum: 'Estoque mínimo na lista' },
    compactSections: ['operations', 'balances'],
  },
  contas: {
    title: 'Contas financeiras',
    sections: {
      accounts: 'Contas',
      categories: 'Categorias financeiras',
      help: 'Entenda os números',
    },
    essentialSections: ['accounts'],
    fields: { timeZone: 'Fuso horário da nova conta' },
    compactSections: ['accounts'],
  },
  precos: {
    title: 'Preços e orçamentos',
    sections: { quote: 'Orçamento' },
    essentialSections: ['quote'],
    fields: { discount: 'Desconto do orçamento' },
    compactSections: ['quote'],
  },
  financas: {
    title: 'Gestão financeira',
    sections: {
      despesas: 'Despesas',
      series: 'Recorrências e parcelas',
      movimentos: 'Aportes e transferências',
      emprestimos: 'Empréstimos e dívidas',
      relatorios: 'Relatórios',
      projecao: 'Projeção de caixa',
      regras: 'Regras de fechamento',
    },
    essentialSections: ['despesas', 'relatorios'],
    fields: { category: 'Categoria da despesa' },
    compactSections: ['despesas', 'relatorios'],
  },
} as const;
export type WorkspaceId = keyof typeof workspacePresentations;
export type WorkspaceListConfig = {
  columns: string[];
  density: 'comfortable' | 'compact';
  sort: string;
};
export type WorkspaceListDefinition = {
  title: string;
  columns: Record<string, string>;
  essential: string[];
  sorts: Record<string, string>;
  defaultSort: string;
};
export const workspaceLists: Partial<Record<WorkspaceId, Record<string, WorkspaceListDefinition>>> =
  {
    balcao: {
      cart: {
        title: 'Itens do balcão',
        columns: {
          product: 'Produto e variação',
          quantity: 'Quantidade',
          price: 'Preço unitário',
          total: 'Subtotal',
        },
        essential: ['product', 'quantity', 'price', 'total'],
        sorts: { insertion: 'Ordem em que os itens foram adicionados' },
        defaultSort: 'insertion',
      },
    },
    contas: {
      accounts: {
        title: 'Lista de contas',
        columns: { name: 'Conta', kind: 'Tipo', state: 'Situação', timeZone: 'Fuso' },
        essential: ['name', 'kind', 'state'],
        sorts: { server: 'Ordem padrão das contas' },
        defaultSort: 'server',
      },
    },
    financas: {
      expenses: {
        title: 'Lista de despesas',
        columns: {
          description: 'Descrição',
          amount: 'Valor',
          paid: 'Pago',
          state: 'Situação',
          dueDate: 'Vencimento',
          competence: 'Data de referência',
        },
        essential: ['description', 'amount', 'paid', 'state', 'dueDate'],
        sorts: { server: 'Ordem padrão das despesas' },
        defaultSort: 'server',
      },
    },
    recebiveis: {
      titles: {
        title: 'Valores das cobranças',
        columns: {
          gross: 'Valor antes das taxas',
          paid: 'Recebido antes das taxas',
          remaining: 'Falta receber',
          fee: 'Taxa prevista',
        },
        essential: ['gross', 'paid', 'remaining'],
        sorts: { server: 'Ordem padrão das cobranças' },
        defaultSort: 'server',
      },
    },
    caixa: {
      sessions: {
        title: 'Lista de sessões',
        columns: {
          terminal: 'Terminal',
          date: 'Data',
          state: 'Situação',
          operator: 'Operador',
          reference: 'Referência',
        },
        essential: ['terminal', 'date', 'state', 'operator'],
        sorts: { server: 'Ordem padrão dos caixas' },
        defaultSort: 'server',
      },
    },
    posvenda: {
      returns: {
        title: 'Devoluções registradas',
        columns: {
          date: 'Data',
          amount: 'Total devolvido',
          mode: 'Compensação',
          refund: 'Valor compensado',
          reason: 'Motivo',
        },
        essential: ['date', 'amount', 'mode', 'refund'],
        sorts: { server: 'Ordem padrão do histórico' },
        defaultSort: 'server',
      },
    },
    compras: {
      purchases: {
        title: 'Pedidos de compra',
        columns: {
          supplier: 'Fornecedor',
          total: 'Total',
          state: 'Situação',
          quantity: 'Itens / recebidos',
          location: 'Local',
        },
        essential: ['supplier', 'total', 'state', 'quantity'],
        sorts: { server: 'Ordem padrão dos pedidos' },
        defaultSort: 'server',
      },
    },
    estoque: {
      balances: {
        title: 'Saldos por local',
        columns: {
          product: 'Produto / variação',
          location: 'Local',
          onHand: 'Físico',
          reserved: 'Reservado',
          blocked: 'Bloqueado total',
          quarantined: 'Quarentena',
          available: 'Disponível',
          minimum: 'Mínimo',
        },
        essential: [
          'product',
          'location',
          'onHand',
          'reserved',
          'blocked',
          'quarantined',
          'available',
        ],
        sorts: { server: 'Ordem padrão dos saldos' },
        defaultSort: 'server',
      },
    },
    encomendas: {
      orders: {
        title: 'Lista de encomendas',
        columns: {
          customer: 'Cliente',
          total: 'Valor',
          state: 'Situação',
          dueDate: 'Entrega',
          reference: 'Referência',
        },
        essential: ['customer', 'total', 'state', 'dueDate'],
        sorts: { server: 'Ordem padrão das encomendas' },
        defaultSort: 'server',
      },
    },
    vendas: {
      history: {
        title: 'Histórico de vendas',
        columns: {
          customer: 'Cliente',
          total: 'Total',
          state: 'Situação',
          reference: 'Referência',
          date: 'Data da venda',
        },
        essential: ['customer', 'total', 'state', 'reference'],
        sorts: { server: 'Mais recentes no servidor' },
        defaultSort: 'server',
      },
    },
    crm: {
      contacts: {
        title: 'Lista de clientes',
        columns: {
          name: 'Nome',
          phone: 'Telefone',
          email: 'E-mail',
          interest: 'Interesse',
          interaction: 'Última interação',
        },
        essential: ['name'],
        sorts: { recent: 'Interação recente', name_asc: 'Nome A–Z', name_desc: 'Nome Z–A' },
        defaultSort: 'recent',
      },
      opportunities: {
        title: 'Lista de oportunidades',
        columns: {
          customer: 'Cliente',
          stage: 'Etapa',
          value: 'Valor',
          nextStep: 'Próximo passo',
          title: 'Descrição',
          updated: 'Atualização',
        },
        essential: ['customer', 'stage', 'value', 'nextStep'],
        sorts: {
          recent: 'Atualização recente',
          oldest: 'Mais tempo sem atualização',
          value_desc: 'Maior valor',
        },
        defaultSort: 'oldest',
      },
    },
  };
export function defaultWorkspaceList(id: WorkspaceId, list: string): WorkspaceListConfig {
  const definition = workspaceLists[id]?.[list];
  if (!definition) throw new Error('Lista não disponível nesta ferramenta.');
  return {
    columns: Object.keys(definition.columns),
    density: 'comfortable',
    sort: definition.defaultSort,
  };
}
export type WorkspaceConfig = {
  version: 1;
  sections: string[];
  fields: string[];
  lists?: Record<string, WorkspaceListConfig>;
};
export type WorkspaceScope = 'company' | 'owner' | 'admin' | 'personal';
export type WorkspaceState = {
  scope: WorkspaceScope;
  inherited: boolean;
  revision: number;
  config: WorkspaceConfig;
  history: { revision: number; config: WorkspaceConfig | null; actor: string; at: string }[];
};
export function defaultWorkspaceConfig(id: WorkspaceId): WorkspaceConfig {
  const d = workspacePresentations[id];
  return { version: 1, sections: Object.keys(d.sections), fields: Object.keys(d.fields) };
}

/** Curated display presets only: no products, access grants or module activation. */
export const workspaceTemplateLabels = {
  fashion: 'Moda',
  workshop: 'Impressão 3D e produção',
} as const;
export type WorkspaceTemplate = keyof typeof workspaceTemplateLabels;
export function workspaceTemplate(id: WorkspaceId, template: WorkspaceTemplate): WorkspaceConfig {
  const definition = workspacePresentations[id];
  const optional: Partial<Record<WorkspaceId, string[]>> =
    template === 'fashion'
      ? {
          crm: ['email'],
          loja: ['tagline', 'featuredCategory'],
          estoque: ['minimum'],
          recebiveis: ['forecastFee'],
        }
      : {
          crm: ['email', 'opportunityTitle'],
          loja: ['about'],
          encomendas: ['notes'],
          precos: ['discount'],
        };
  const fields = (optional[id] ?? []).filter((field) => field in definition.fields);
  return {
    version: 1,
    sections: [...definition.compactSections],
    fields,
    lists: Object.fromEntries(
      Object.entries(workspaceLists[id] ?? {}).map(([key, list]) => [
        key,
        {
          columns: template === 'fashion' ? Object.keys(list.columns) : [...list.essential],
          density: template === 'fashion' ? 'comfortable' : 'compact',
          sort: list.defaultSort,
        },
      ]),
    ),
  };
}
